import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { BiLogOut } from "react-icons/bi";
import { actions } from "../../redux/store/store";
import { useLogoutMutation } from "../../api/auth";

const Header = ({ userManager, isDevMode }) => {
  const loc = useLocation();
  const [logout] = useLogoutMutation();
  const { firstName, lastName } = useSelector(
    (state) => state.auth.currentUser || {}
  );
  // const { data: totalBalance, isLoading } = useGetTotalBalanceQuery({
  //   refetchOnMountOrArgChange: true,
  // });

  // const logOut = () => {
  //   Cookies.remove("password");
  //   dispatch(logout());
  //   navigate("/login");
  // };
  const performLogout = useCallback(
    async (e) => {
      e.preventDefault();
      const token = localStorage.getItem('authToken');
      if (token) {
        localStorage.removeItem('authToken');
        await userManager.removeUser();
        await userManager.signoutRedirect();
      } else {
        logout();
      }
      actions.auth.setCurrentUser(null);
    },
    [userManager]
  );

  return (
    ![
      "/healthCheck",
      "/login",
      "/register",
      "/confirmation",
      "/forgotPassword",
      "/resetPassword",
    ].includes(loc.pathname) && (
      <nav className="main-header navbar navbar-expand navbar-white">
        <span
          className="nav-link"
          data-widget="pushmenu"
          style={{
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <i className="fas fa-bars" />
        </span>
        <h3
          style={{
            textTransform: "capitalize",
            marginBottom: "0",
          }}
        >Welcome to Better Trucks Shift Admin {`${isDevMode ? "(Test)" : ""}`}
        </h3>

        <ul className="navbar-nav ml-auto">
          {/* 
        <li className="nav-item dropdown">
            <button className="btn btn_block btn_accent">
                Add Balance <IoAdd className="btn__icon btn__icon_right"/>
          </button>
        </li> */}
          {/* {currentUser && currentUser.role === "root" && (
              <li className="nav-item dropdown">
                <p style={{ fontWeight: "600", margin: "0.8rem" }}>
                  Balance: ${"0.00"}
                </p>
              </li>
            )} */}

          <li className="nav-item dropdown">
            <span
              style={{ border: "none", color: "black", fontWeight: "normal" }}
              href=""
              className="btn"
              onClick={performLogout}
            >
              <BiLogOut className="icon_logout" /> Log out
            </span>
          </li>
        </ul>
      </nav>
    )
  );
};

export default Header;
